// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageSquare as RawLucideMessageSquare } from "lucide-react";
export const LucideMessageSquare = /* @__PURE__ */ createIcon(RawLucideMessageSquare, "LucideMessageSquare", 2);
